import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"
import _imports_0 from '@/assets/icons/plus-black.svg'
import _imports_1 from '@/assets/icons/trash.svg'


const _hoisted_1 = { class: "admin-page-wr" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "breadcrumb-wrapper-main" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "current-breadcrumb" }
const _hoisted_6 = {
  key: 0,
  class: "card"
}
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "info-wr" }
const _hoisted_9 = { class: "block" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row-value" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "row-value" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "row-value" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "row-value d-flex" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "row-value" }
const _hoisted_20 = { class: "block" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "controls" }
const _hoisted_24 = { class: "controls--top" }
const _hoisted_25 = { class: "lawyer-row" }
const _hoisted_26 = { class: "lawyer-block" }
const _hoisted_27 = {
  key: 0,
  class: "lawyer-info"
}
const _hoisted_28 = {
  key: 0,
  class: "dot"
}
const _hoisted_29 = {
  key: 1,
  class: "lawyer-info"
}
const _hoisted_30 = { class: "wrapper-switch" }
const _hoisted_31 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'AdminUser', params: { userId: $setup.userId } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.getFirstLastName($setup.user)), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "delimiter" }, null, -1)),
          _createElementVNode("div", _hoisted_5, _toDisplayString($setup.estate ? $setup.estate.title : ""), 1)
        ])
      ]),
      ($setup.estate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row-title" }, "Estate:", -1)),
                    _createElementVNode("div", _hoisted_11, _toDisplayString($setup.estate.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row-title" }, "App Version:", -1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString($setup.estate.appVersion || "v1"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row-title" }, "Address:", -1)),
                    _createElementVNode("div", _hoisted_15, _toDisplayString($setup.estate.address), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row-title" }, "Initial Deposit:", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", null, _toDisplayString($setup.formatPrice($setup.estate.initDeposit / 100)), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(["badge success", { yellow: !$setup.estate.isRefundable }])
                      }, _toDisplayString($setup.estate.isRefundable ? "Refundable" : "Not refundable"), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row-title" }, "Icon Color:", -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", {
                        class: "color",
                        style: _normalizeStyle({ 'background-color': $setup.estate.iconColor })
                      }, null, 4)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "row-title second" }, "Logo:", -1)),
                    _createElementVNode("img", {
                      class: "logo",
                      src: $setup.estate.logoUrl
                    }, null, 8, _hoisted_22)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode($setup["InputFile"], {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($event.target.value = '')),
                  onChange: $setup.onImportListing,
                  text: "Import Listing",
                  accept: "text/xml"
                }),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_router_link, {
                    class: "button default edit",
                    to: { name: 'AdminEstateUpdate', params: { userId: $setup.userId, estateId: $setup.estateId } }
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createTextVNode("Edit Estate", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode($setup["ToggleButton"], {
                    onChange: $setup.onChangeActiveEstate,
                    modelValue: $setup.isActiveEstate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.isActiveEstate) = $event)),
                    label: $setup.isActiveEstate ? 'Active' : 'Draft'
                  }, null, 8, ["modelValue", "label"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "lawyer-label" }, "Trust account:", -1)),
                ($setup.estate.lawyerId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createTextVNode(_toDisplayString($setup.estate.lawyerId?.detailsId?.companyName), 1),
                      ($setup.estate?.lawyerId?.detailsId?.companyAddress)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString($setup.estate?.lawyerId?.detailsId?.companyAddress), 1),
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "dot" }, null, -1)),
                      _createTextVNode(_toDisplayString($setup.lawyerName), 1),
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "dot" }, null, -1)),
                      _createTextVNode(_toDisplayString($setup.estate.lawyerId.phone), 1),
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "dot" }, null, -1)),
                      _createTextVNode(_toDisplayString($setup.estate.lawyerId.email), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, "-"))
              ]),
              _createElementVNode("div", null, [
                (!$setup.estate.lawyerId)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button button-with-icon",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showAddLawyerModal = true))
                    }, [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("img", { src: _imports_0 }, null, -1),
                      _createTextVNode("Connect Trust account", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "button button-with-icon remove",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showConfirmDeleteLawyerModal = true))
                    }, [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("img", { src: _imports_1 }, null, -1),
                      _createTextVNode("Disconnect Trust account", -1)
                    ]))]))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createVNode($setup["SwitchComponent"], {
        "model-value": $setup.currentTab,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.toTab($event.label))),
        list: $setup.tabs,
        slots: ['customSwitch']
      }, {
        customSwitch: _withCtx((item) => [
          _createElementVNode("span", {
            class: "switch-item--text",
            onClick: ($event: any) => ($setup.toTab(item.label))
          }, _toDisplayString(item.label), 9, _hoisted_31)
        ]),
        _: 1
      }, 8, ["model-value", "list"])
    ]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, { include: ['AdminMasterplanEditor', 'AdminEstateHomeDesigns'] }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            class: _normalizeClass({ 'doc-wr': $setup.currentTab && $setup.currentTab.label === 'documents' }),
            role: $setup.UserRoles.SUPER_ADMIN
          }, null, 8, ["class", "role"]))
        ], 1024))
      ]),
      _: 1
    }),
    _createVNode($setup["AddLawyerToEstateModal"], {
      "is-open": $setup.showAddLawyerModal,
      "estate-name": $setup.estate?.title || '',
      onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.showAddLawyerModal = false)),
      onLawyerId: $setup.onGetLawyerId
    }, null, 8, ["is-open", "estate-name"]),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.showConfirmDeleteLawyerModal,
      deleteItem: $setup.lawyerName,
      onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.showConfirmDeleteLawyerModal = false)),
      onConfirm: $setup.onRemoveLawyer
    }, null, 8, ["isOpen", "deleteItem"]),
    _createVNode($setup["SelectImportedListingModal"], {
      isOpen: $setup.isSelectImportedModalOpen,
      listings: $setup.importedListingData,
      onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.isSelectImportedModalOpen = false))
    }, null, 8, ["isOpen", "listings"])
  ]))
}